export default __webpack_public_path__ + "media/images/close-4635df70e38159c6d9172deb18bd244f.svg";